// Competency "dot meter" encoding (Resources page).
//
// Sibling of constraint-colors.ts, but deliberately a different visual language:
//   • shape     = round dots (constraints use square cells)
//   • hue       = a single teal (~178°), outside the constraint blue→purple ramp
//   • fill      = the grade itself, 1→5, filling the 5-dot meter left→right
//
// Competencies are graded 1–5 (NULL = unrated → an all-empty meter). The teal +
// round shape make "competency" unmistakable from the "constraint" matrix when the
// bench is scanned. Colors live as brand tokens (--comp-teal / --comp-dot-empty in
// design-system/tokens.css); this module is the single source of truth for order,
// labels, and scale.

// Canonical competencies in their fixed display order (§4.3). The data layer stores
// full names (Consulting / Project Management / Product Management); the meter shows
// the short label with the full name in its tooltip + screen-reader text.
export const COMPETENCY_ORDER = ["Consulting", "Product Management", "Project Management"] as const;

// Display abbreviations for the meter labels. Full names stay in tooltips/aria so
// the abbreviation never stands alone (terminology discipline §2.4).
export const COMPETENCY_SHORT: Record<string, string> = {
  Consulting: "C",
  "Product Management": "PdM",
  "Project Management": "PM",
};

// Dots per meter — the grade scale is 1–5.
export const COMPETENCY_SCALE_MAX = 5;

export function competencyShort(name: string): string {
  return COMPETENCY_SHORT[name] ?? name.slice(0, 2).toUpperCase();
}
